import { render, staticRenderFns } from "./MPopupUploadLogoData.vue?vue&type=template&id=c0130e7e&"
import script from "./MPopupUploadLogoData.vue?vue&type=script&lang=ts&"
export * from "./MPopupUploadLogoData.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports